import React from "react";
import {graphql} from "react-apollo";
import { getUserQuery } from "../graph";
import Loading from "../../etc/Loading";
import StatusModal from "./StatusModal";

import { Link } from "react-router-dom";
import PeopleIcon from "@material-ui/icons/People";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import DoneIcon from "@material-ui/icons/Done";
import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";
import IconCard from "components/Cards/IconCard.jsx";

import Button from "components/CustomButtons/Button.jsx";
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
        fontSize: 20,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
});

class ViewUser extends React.Component {
    constructor(props){
        super(props);
        this.state = { statusModalIsOpen: false }
    }

    onStatusBtnClicked() {
        this.setState({
            statusModalIsOpen: true
        });   
    }

    onStatusModalCallback(id, newStatus) {
        this.props.data.refetch();
    }

    onStatusModalClose() {
        this.setState({
            statusModalIsOpen: false
        });
    }

    render(){
        if(this.props.data.loading){
            return <Loading />
        }

        let user = this.props.data.user
        let statusBtn;
        let statusText = "ACTIVE";
        let statusTextColor = "#f0ad4e";
        let classes = this.props.classes;
        let { statusModalIsOpen } = this.state;
        let statusModal = null;

        if (statusModalIsOpen)
            statusModal = <StatusModal 
                            user={user} 
                            onStatusModalCallback={this.onStatusModalCallback.bind(this)}
                            statusModalIsOpen={statusModalIsOpen}
                            onStatusModalClose={this.onStatusModalClose.bind(this)}/>
        statusBtn = <button />
        try {
            if (user.active) {
                statusBtn = (<Button onClick={this.onStatusBtnClicked.bind(this)} size='sm'>
                                <DeleteIcon size='sm' /> Deactivate
                            </Button>);
            }
            else {
                statusBtn = (<Button onClick={this.onStatusBtnClicked.bind(this)} size='sm'>
                                <DoneIcon size='sm' /> Activate
                            </Button>);
                statusText = "DEACTIVATED";
                statusTextColor = "#d9534f";
            }
        } catch (e){
            
        }

        let actions = (user != null ) ? 
                            <div>
                                <Link to={"/users/"}  size='sm'>
                                    <Button variant="raised" className={classes.button} size='sm' style={{flex: 1}}>
                                        <ChevronLeft size='sm'/> Back
                                    </Button>
                                </Link>
                                <Link to={"/users/" + user.uid + "/update"} size='sm'>
                                    <Button variant="raised" className={classes.button} size='sm' style={{flex: 1}}>
                                        <EditIcon size='sm' /> Update
                                    </Button>
                                </Link>
                                {statusBtn}
                            </div>
                        : null;

        let user_details = (user != null ) ?
                            <div>
                                <div className="row">
                                </div>
                                <div className="row invoice-info">
                                    <div className="col-sm-4 invoice-col">
                                        Username
                                        <address>
                                            <strong>{ user.username }</strong>
                                        </address>
                                        Usertype
                                        <address>
                                            <strong>{ (user.usertype === process.env.REACT_APP_PM_ROLE) ? "Project Manager" : "Field Work Partner" }</strong>
                                        </address>
                                        Country
                                        <address>
                                            <strong>{ (user.address != null) ? user.address.toUpperCase() : "Not Set" }</strong>
                                        </address>
                                        
                                    </div>
                                    <div className="col-sm-4 invoice-col">
                                        Last Login
                                        <address>
                                            <strong>2/15/2018 15:00:00</strong>
                                        </address>
                                    </div>
                                    <div className="col-sm-4 invoice-col">
                                        User Status
                                        <address>
                                            <strong style={{color: statusTextColor}}>{statusText}</strong>
                                        </address>
                                    </div>
                                </div>
                            </div>
                        : null;

        return(
            <div>
                { statusModal }
                <GridContainer>
                    <ItemGrid xs={9} style={{marginLeft: '17px'}}>
                        <IconCard
                            icon={ PeopleIcon }
                            title="User"
                            content={ user_details }
                            footer={actions}
                        />
                    </ItemGrid>
                </GridContainer>
                
            </div>
        )
    }
}

export default withStyles(styles) (graphql(getUserQuery,{
    options: (props) => ({
        variables: { uid: props.match.params.uid },
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all',
    })
})(ViewUser));


// WEBPACK FOOTER //
// ./src/views/users/components/View.js